import React, { createContext, useEffect, useState } from 'react';
import UserProfile from './UserProfile';


export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {

  const [showInformation, setShowInformation] = useState(false);

  const updateShowInformation = () => {
    setShowInformation(!showInformation);
  };

  const globalState = {
    showInformation,
    setShowInformation,
    updateShowInformation,
  };

  return (
    <GlobalContext.Provider value={globalState}>
      {children}
    </GlobalContext.Provider>
  );
};
